<script lang="ts" setup>
import { computed } from 'vue'
import { STATUS_LABEL, STATUS_TONE } from '~/logic/connectionStatus'
import type { UXConnectionStatus } from '~/logic/connectionStatus'

const props = defineProps<{
  status: UXConnectionStatus
}>()

const label = computed(() => STATUS_LABEL[props.status])
const tone = computed(() => STATUS_TONE[props.status])

const pillClasses = computed(() => {
  const baseClasses =
    'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium border'

  switch (tone.value) {
    case 'ok':
      return `${baseClasses} bg-green-50 text-green-700 border-green-200`
    case 'err':
      return `${baseClasses} bg-red-50 text-red-700 border-red-200`
    case 'warn':
      return `${baseClasses} bg-orange-50 text-orange-700 border-orange-200`
    case 'neutral':
    default:
      return `${baseClasses} bg-gray-50 text-gray-700 border-gray-200`
  }
})
</script>

<template>
  <div :class="pillClasses">
    <!-- MDI icons throughout (project standard per CLAUDE.md). w-4 h-4 keeps
         them at the visual weight the akar-icons originals had. -->
    <i-mdi:check-circle v-if="status === 'connected'" class="w-4 h-4" />
    <i-mdi:close-circle v-else-if="status === 'failing'" class="w-4 h-4" />
    <i-mdi:help-circle v-else-if="status === 'not_set_up'" class="w-4 h-4" />
    <i-mdi:pause-circle v-else-if="status === 'paused'" class="w-4 h-4" />
    <i-mdi:minus-circle v-else-if="status === 'not_used'" class="w-4 h-4" />
    <span class="truncate leading-4">{{ label }}</span>
  </div>
</template>
